export default __webpack_public_path__ + "static/media/subtitle-style-2.0eca5588.webp";